import { createSupabaseApi } from './supabaseApi';

const API_BASE = '';

export const createApiClient = (user) => createSupabaseApi(user);

export const apiGet = (api, url, params) => api.get(url, { params });
export const apiPost = (api, url, data) => api.post(url, data);
export const apiPut = (api, url, data) => api.put(url, data);
export const apiDelete = (api, url) => api.delete(url);

export { API_BASE };
